import React, { memo } from 'react';
import { View, StyleSheet, Text } from 'react-native';

import { FONTS, FONT_SIZES } from '@bcm/constants';
import { defaultBorder, defaultPadding } from '../styles/common';
import IconButton from '../button/IconButton';

const CardHeader = (props) => {
	return (
		<View style={styles.headerContainer}>
			<View style={styles.headerTitleContainer}>
				<Text numberOfLines={1} style={styles.headerTitle}>
					{props.title}
				</Text>
			</View>
			{props.isHeaderButtons && props.headerButtons && props.headerButtons.length && <View style={styles.headerIconsContainer}>
				{
					props.headerButtons.map((button => {
						if (button && !button.isHidden) {
							return (
								<IconButton
									key={button.icon.name}
									{...button}
								/>
							);
						}
					}))
				}
			</View>}
		</View>
	);
};

const styles = StyleSheet.create({
	headerContainer: {
		borderTopRightRadius: defaultBorder,
		borderTopLeftRadius: defaultBorder,
		padding: defaultPadding,
		flexDirection: 'row',
	},
	headerTitleContainer: {
		flex: 1,
	},
	headerTitle: {
		height: 30,
		textAlignVertical: 'center',
		fontSize: FONT_SIZES.xl,
		margin: 5,
		fontFamily: FONTS.bold,
	},
	headerIconsContainer: {
		flexDirection: 'row',
		justifyContent: 'space-evenly'
	},
});

export default memo(CardHeader);